import { inject, type Provider } from '@angular/core';

import { ENTITY_CACHES, type EntityCaches } from '@blaze-shared/auth-data-access';
import { ConnectorsCollectionService } from '@blaze-shared/connectors-data-access';
import {
  DatasetsCollectionService,
  TablesCollectionService,
} from '@blaze-shared/datasets-data-access';
import { ProjectsCollectionService } from '@blaze-shared/projects-data-access';
import { VariablesCollectionService } from '@blaze-shared/variables-data-access';

/** Binds the caches sign-out clears; the app shell is the only place that sees all of them. */
export function provideEntityCaches(): Provider {
  return {
    provide: ENTITY_CACHES,
    useFactory: (): EntityCaches => {
      const caches = [
        inject(ConnectorsCollectionService),
        inject(DatasetsCollectionService),
        inject(ProjectsCollectionService),
        inject(TablesCollectionService),
        inject(VariablesCollectionService),
      ];
      return { clearAll: (): void => caches.forEach((cache) => cache.clearCache()) };
    },
  };
}
